// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { SpanWithData } from '../'

import { InfoDetail } from './InfoDetail'

import { readablePhoneNumber } from '../../utils'

export const ClientInformation = ({ name, id, employmentType, preferredCallTime, preferredContactNumber, bankDetails }) => (
  <div className='slds-p-top_small slds-p-bottom_small slds-p-left_medium slds-m-bottom_medium' style={{ backgroundColor: '#f5f5f5'}}>
    <div className='u-font-size-larger slds-m-bottom_small'>
      <b>Client Information</b>
    </div>
    <InfoDetail label='Name' value={name} />
    <InfoDetail label='ID' value={id} />
    <InfoDetail label='Employment' value={<SpanWithData forField='ClientEmploymentType' searchKey={employmentType} />} />
    <InfoDetail label='Preferred calltime' value={<SpanWithData forField='LoanApplicationCalltime' searchKey={preferredCallTime} />} />
    <InfoDetail label='Preferred contact number' value={preferredContactNumber ? readablePhoneNumber(preferredContactNumber) : 'Unknown'} />
    <InfoDetail label='Bank account' value={bankDetails} />
  </div>
)

ClientInformation.propTypes = {
  name: PropTypes.string,
  id: PropTypes.element,
  preferredCallTime: PropTypes.string,
  preferredContactNumber: PropTypes.string,
  bankDetails: PropTypes.element
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-info/ClientInformation.js